import Title from "antd/es/typography/Title";
import React, { useEffect, useState } from "react";
import { useAuth } from "../../../contexts/auth";
import { Balance } from "../../../components/Financial/Balance";
import CardsTable from "../../../components/Financial/CardsTable";
import Credit from "../../../components/Financial/Credit";
import PaymentsTable from "../../../components/Financial/PaymentsTable";
import { loadStripe } from "@stripe/stripe-js/pure";
import { Elements } from "@stripe/react-stripe-js";
import { userPayments } from "../../../services/account/api";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { FormattedMessage } from "react-intl";

export default function Financial() {
  const { partner } = useAuth();
  const stripeInstance = loadStripe(partner.spk);
  const [selectedCard, setSelectedCard] = useState();
  const [payments, setPayments] = useState([])
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    loadPayments()
  }, [])

  const loadPayments = () => {
    userPayments()
      .then((res) => {
        setPayments(res.data);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false))
  }

  if (isLoading) {
    const antIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />;

    return (
      <div className="flex justify-center items-center">
        <Spin size="large" indicator={antIcon} />
      </div>
    );
  }

  return (
    <div>
      <div className="grid grid-cols-1 mt-5">
        <Balance />
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 gap-x-20 mt-5">
        <div className="py-5">
          <Title level={5} style={{ margin: 0 }} className="!mb-6">
            <FormattedMessage id="page.my_account.financial.add_credits_title" />
          </Title>
          <Elements stripe={stripeInstance}>
            <Credit card={selectedCard} onFinish={() => loadPayments()} />
          </Elements>
        </div>
        <div className="py-5">
          <Title level={5}>
            <FormattedMessage id="page.my_account.financial.payments_methods" />
          </Title>
          <CardsTable stripeInstance={stripeInstance} onChangeCard={setSelectedCard} />
        </div>
        <div className="py-5">
          <Title level={5}>
            <FormattedMessage id="page.my_account.financial.payments" />
          </Title>
          <PaymentsTable payments={payments} />
        </div>
      </div>
    </div >
  )
}
